<template>
    <pendo-icon-button
        class="copy-to-clipboard"
        icon="copy"
        icon-size="16"
        @click="handleCopy" />
</template>

<script>
import { PendoIconButton } from '@pendo/components';
import { parseMessageContent } from '@/vuex/modules/ask-pendo/ask-pendo.utils';
import { renderMarkdown } from '@/common/marked/markdown.utils';

export default {
    name: 'CopyMessage',
    components: {
        PendoIconButton,
    },
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    emits: ['copied'],
    methods: {
        async handleCopy () {
            if (navigator && navigator.clipboard) {
                try {
                    const { content } = parseMessageContent(this.message);

                    const clipboardItem = new ClipboardItem({
                        'text/html': renderMarkdown(content),
                        'text/plain': renderMarkdown(content, 'plaintext'),
                    });

                    await navigator.clipboard.write([clipboardItem]);
                    this.$emit('copied');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Failed to copy text to clipboard', error);
                }
            }
        },
    },
};
</script>
